window.onload = function () {
	document.body.style.zoom = "normal"; //避免zoom尺寸叠加
	let scale = document.body.clientWidth / 1080;
	document.body.style.zoom = scale;
	judgeClientForMobile();

};
(function () {
	var throttle = function (type, name, obj) {
		obj = obj || window;
		var running = false;
		var func = function () {
			if (running) {
				return;
			}
			running = true;
			requestAnimationFrame(function () {
				obj.dispatchEvent(new CustomEvent(name));
				running = false;
			});
		};
		obj.addEventListener(type, func);
	};

	/* init - you can init any event */
	throttle("resize", "optimizedResize");
})();
window.addEventListener("optimizedResize", function () {
	document.body.style.zoom = "normal";
	let scale = document.body.clientWidth / 1080;
	document.body.style.zoom = scale;
	judgeClientForMobile();
});

/**
 * 判断客户端类型
 * true:移动端  false  PC端
 * @export
 * @return {*}
 */
function judgeClientForMobile() {
	let client = false;
	if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
		//判断iPhone|iPad|iPod|iOS
		client = true;
		// 设置样式
		// $(".buy-btn").css("font-size", "14px");
		// $(".buy-now-operation").css("font-size", "24px");
		// $(".color-item li ").css("font-size", "18px");
		// $(".shape-item li ").css("font-size", "16px");
		// $(".color-content .title").css("font-size", "18px");
		// $(".shape-content .title").css("font-size", "18px");
		// $(".step_item p").css("font-size", "22px");
		// $(".step_item p").css("font-size", "22px");
		// $(".buy").css("font-size", "18px");
		// $(".step_one_row li p:nth-child(1)").css("font-size", "24px");
		// $(".step_one_row li p:nth-child(2)").css({"font-size": "14px",bottom:'16%'});
		// $(".price-product p:nth-child(1)").css("font-size", "32px");
		// $(".price-product p:nth-child(2)").css("font-size", "20px");
		// $(".random_item_top ul li").css("font-size", "26px");
		// $(".random_item_top .randow").css("font-size", "14px");
		// $(".random_item p").css("font-size", "12px");
	} else {
		client = false;
	}
	// alert(client);
}

// (function (WIN) {
// 	var setFontSize = (WIN.setFontSize = function (_width) {
// 		var docEl = document.documentElement;
// 		// 获取当前窗口的宽度
// 		var width = _width || docEl.clientWidth; // docEl.getBoundingClientRect().width;

// 		// 大于 1080px 按 1080
// 		if (width > 1080) {
// 			width = 1080;
// 		}

// 		var rem = width / 10;
// 		console.log(rem);

// 		docEl.style.fontSize = rem + "px";

// 		// 部分机型上的误差、兼容性处理
// 		var actualSize =
// 			win.getComputedStyle &&
// 			parseFloat(win.getComputedStyle(docEl)["font-size"]);
// 		if (
// 			actualSize !== rem &&
// 			actualSize > 0 &&
// 			Math.abs(actualSize - rem) > 1
// 		) {
// 			var remScaled = (rem * rem) / actualSize;
// 			docEl.style.fontSize = remScaled + "px";
// 		}
// 	});

// 	var timer;
// 	//函数节流
// 	function dbcRefresh() {
// 		clearTimeout(timer);
// 		timer = setTimeout(setFontSize, 100);
// 	}

// 	//窗口更新动态改变 font-size
// 	WIN.addEventListener("resize", dbcRefresh, false);
// 	//页面显示时计算一次
// 	WIN.addEventListener(
// 		"pageshow",
// 		function (e) {
// 			if (e.persisted) {
// 				dbcRefresh();
// 			}
// 		},
// 		false
// 	);
// 	setFontSize();
// })(window);
